import { ModelError } from '../models/ModelError';
import { Functions } from './Functions';

export class BaseComponent {
  public Errors: ModelError[] = [];

  protected addErrorFromModelState(
    errors: { [key: string]: string[] },
    prefix: string = '',
    isPersistent?: boolean
  ): void {
    const modelErrors = ModelError.parseFromModelState(errors, prefix, isPersistent);
    this.Errors = [...this.Errors, ...modelErrors];
  }

  protected addError(
    errorOrKey: ModelError | string,
    errors?: string | string[],
    isPersistent?: boolean
  ): void {
    if (errorOrKey instanceof ModelError) {
      this.Errors = [...this.Errors, errorOrKey];
    } else {
      this.Errors = [...this.Errors, new ModelError(errorOrKey, errors, isPersistent)];
    }
  }

  protected cleanError(key?: string): void {
    if (!key) {
      this.Errors = [];
    } else {
      this.Errors = this.Errors.filter(error => error.Key !== key);
    }
  }
}
